"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth-context";
import { readGuestGarden } from "@/lib/guest-garden";
import { Onboarding } from "./onboarding";

/**
 * Public entry to the editor — the destination of every "dessiner mon potager"
 * call to action across the catalogue.
 *
 * Three questions, then a plan that already has beds and plants in it. The
 * blank canvas was the thing people bounced off.
 */
export default function TryPage() {
  const router = useRouter();
  const { user, loading } = useAuth();

  // Read once, at first render. On the server this yields null and the page
  // renders the spinner, which is also what the client renders while the
  // session is loading — so hydration matches either way.
  const [existing] = useState(() => readGuestGarden());

  useEffect(() => {
    if (loading) return;

    // Signed in: no reason to hand out a throwaway local plan.
    if (user) {
      router.replace("/dashboard");
      return;
    }

    // Coming back mid-plan: straight to the work, don't ask again.
    if (existing) {
      router.replace(`/dashboard/garden/${existing.id}`);
    }
  }, [loading, user, existing, router]);

  if (loading || user || existing) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6">
        <div
          className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin"
          role="status"
          aria-label="Chargement"
        />
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-16">
      <Onboarding />
    </main>
  );
}
